module.exports = __webpack_public_path__ + "media/landing/homepage-drone-000c7c37.png";